import { InviteeStatus } from '@front-app/services/GroupInvitationCampaignApi/model';

export enum AllButtonOption {
	ALL = 'all',
}

export type InviteeButtonOption = Exclude<InviteeStatus, InviteeStatus.REMOVED> | AllButtonOption;
